import { Component, Input, NgZone, OnInit } from '@angular/core';
import { Message, MessageKind } from '../../models/message';
import { MessageService } from '../../services/message.service';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss']
})
export class MessageComponent {

  @Input() public message: Message;

  // Used by the view, to inform the user that e.g. marking the message as read is in progress (network activity)
  isLoading = false;

  constructor(
    private messageService: MessageService,
    private zone: NgZone,
  ) {
  }

  /**
   * The message kind as a string, to be used by the view
   */
  get messageKind(): string {
    return MessageKind[ this.message.kind ];
  }

  /**
   * The name for the mat-icon in relation to the message kind
   */
  get matIconName(): string {
    const matIconNames = {
      info: 'info',
      warning: 'warning',
      success: 'check_circle',
      notification: 'error_outline',
    };
    return matIconNames[ this.messageKind ];
  }

  // ===== Message operations ===== //

  /**
   * Mark a message as read.
   * Only strictly needed for messages with kind notification, i.e. messages coming from the backend.
   * For other messages, it just dismisses the message.
   */
  markAsRead(): void {
    if (this.message.isNotification) {
      this.setLoading(true);
      this.messageService.markAsRead(this.message)
        .then(() => this.setLoading(false))
        .catch(someError => {
          this.messageService.add(Message.warning(someError.toString()), 2000);
          this.setLoading(false);
        });
    } else {
      if (!this.message.isInfo) {
        this.messageService.remove(this.message);
      }
    }
  }

  /**
   * Inform the view about the loading state
   *
   * @param isLoading Boolean indicating if the UI should show inform the user about some activity
   */
  private setLoading(isLoading: boolean): void {
    this.zone.run(() => this.isLoading = isLoading);
  }

}
